import { useState, useEffect } from "react";
import { partial } from "ramda";

import { RequestStatus } from "types/requests";

export default function useOnRequestStatus(
  targetStatus: RequestStatus,
  onStatus: () => void,
  currentStatus: RequestStatus
) {
  // By default, run only once
  const [hasRun, setHasRun] = useState(false);

  useEffect(
    () => {
      if (!hasRun && currentStatus === targetStatus) {
        setHasRun(true);
        onStatus();
      }
    },
    [onStatus, targetStatus, currentStatus, hasRun]
  );
}

const useOnRequestSuccess = partial(useOnRequestStatus, [
  RequestStatus.SUCCESS,
]);
const useOnRequestRequesting = partial(useOnRequestStatus, [
  RequestStatus.REQUESTING,
]);
const useOnRequestFailure = partial(useOnRequestStatus, [
  RequestStatus.FAILURE,
]);

export { useOnRequestSuccess, useOnRequestRequesting, useOnRequestFailure };
